// extracted by mini-css-extract-plugin
module.exports = {"CurrentTurn":"CurrentTurn_CurrentTurn__1yRpg","Label":"CurrentTurn_Label__3m1qJ","Value":"CurrentTurn_Value__3XxvD"};